import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ios-install-dialog',
    templateUrl: './ios-install-dialog.component.html',
    styleUrls: ['./ios-install-dialog.component.scss'],
    standalone: false
})
export class IosInstallDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
